<p-toast 
    [position]="position" 
    [showTransitionOptions]="position === 'center' ? '0ms' : '300ms'" 
    [hideTransitionOptions]="position === 'center' ? '0ms' : '300ms'">
</p-toast>
